import axios from 'axios';
import config from './config';

// export const APIHost = 'http://10.50.51.175:8000';   // localhost office
// // export const APIHost = 'http://192.168.1.7:8000';   // localhost home
// // export const APIHost = 'http://192.168.43.63:8000';   // localhost mobile hotspot
// // export const APIHost = 'https://mvis-dp.as.r.appspot.com';   // GAE: MVIS-DP (dev)
const APIHost = config.APIHost;

export const urlAPI = APIHost + '/api';
export const versionAPI = '/v1';

export function getCarbrand(){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    return axios.get(urlAPI + versionAPI + '/opt/carbrands')
        .then(res => {
            return res
        }).catch(err => {
            return err.res
        })
}
export function getCarmodel(){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    return axios.get(urlAPI + versionAPI + '/opt/carmodels')
        .then(res => {
            return res
        }).catch(err => {
            return err.res
        })
}


// export function getCarcolor(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/carcolors',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getVehicletypes(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/vehicletypes',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getPolicestations(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/policestations',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function genDrvlicensetypes(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/drvlicensetypes',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getPolicytype(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/policytypes',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getAcctype(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/accidenttypes',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getClaimverdicts(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/claimverdicts',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getClaimtype(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/claimtypes',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getAmphur(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/amphurs',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getTumbon(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/tumbons',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getProvince(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/provinces',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function GetStatusCase(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/statuscases',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetSurveyCompanyID(sys_companyID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/surveyorsbycompany?system_company='+sys_companyID,{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetSystemBranch(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/systembranch',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetSystemCompany(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/systemcompany',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetSystemRole(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/systemrole',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetSystemZone(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/systemzone',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetStatusSurvey(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/statussurveyors',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetPropertytypes(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/propertytypes',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetCompanyOTHS(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/companies',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// // export function GetCompanyvoluntaries(){
// //     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
// //     return axios.get(urlAPI + versionAPI + '/opt/companyvoluntaries',{
// //         headers: {
// //             Authorization: headers
// //         }
// //     }).then(res => {
// //         return res
// //     }).catch(err => {
// //         return err.res
// //     })
// // }
// export function GetRelationships(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/relationships',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetRelatedAccident(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/relatedaccidents',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function getRequestFixPlace(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/requestfixplace',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function GetPlatecolors(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/platecolors',{
//         headers: {
//             Authorization: headers
//         }
//     }).then(res => {
//         return res
//     }).catch(err => {
//         return err.res
//     })
// }
// export function getAccidentzones(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/accidentzones',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getDhipayaBranch(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/sysDhipaya_branch',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }

// export function getPoolType(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/pool_type',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getPartnerBranch(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/partner_branch',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getPool(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/pool_type',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getOptDamageLevel(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/damagelevels',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getCarPart(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/carparts',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function getOptDamageType(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/opt/damagetypes',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
